if ( typeof MegaNav !== 'function' ) {

	class MegaNav extends HTMLElement {

		constructor(){

			super();

			this.OPEN_DELAY = 90;
			this.CLOSE_DELAY = 160;

			this._openTimer = null;
			this._closeTimer = null;
			this._current = null;

			this.items = Array.from(this.querySelectorAll('.mega-nav__item--has-panel'));
			this.isTouch = document.body.classList.contains('touchevents');

			this.mount();

		}

		mount(){

			if ( this.closest('.sticky-header') ) {
				setTimeout(()=>{
					this.syncIds();
				}, 0);
			}

			this.items.forEach(item=>{

				const toggle = item.querySelector('[data-mega-nav-toggle]');
				const panel = item.querySelector('[data-mega-nav-panel]');

				if ( ! toggle || ! panel ) return;

				item.addEventListener('mouseenter', ()=>{
					if ( this.isTouch ) return;
					this.scheduleOpen(item);
				});

				item.addEventListener('mouseleave', ()=>{
					if ( this.isTouch ) return;
					this.scheduleClose();
				});

				toggle.addEventListener('click', e=>{
					if ( ! this.isTouch ) return;
					if ( ! item.classList.contains('is-open') ) {
						e.preventDefault();
						this.open(item);
					}
				});

				toggle.addEventListener('focus', ()=>{
					this.open(item);
				});

				item.addEventListener('focusout', e=>{
					if ( ! item.contains(e.relatedTarget) ) {
						this.close(item);
					}
				});

			});

			this.addEventListener('keyup', e=>{
				if ( e.key === 'Escape' || e.keyCode === 27 ) {
					if ( this._current ) {
						const toggle = this._current.querySelector('[data-mega-nav-toggle]');
						this.close(this._current);
						if ( toggle ) toggle.focus();
					}
				}
			});

			this._RESIZE_Handler = () => {
				this.positionAll();
			};
			window.addEventListener('resize', this._RESIZE_Handler, {passive:true});

			requestAnimationFrame(()=>{
				this.positionAll();
			});

			if ( document.fonts && document.fonts.ready ) {
				document.fonts.ready.then(()=>{
					this.positionAll();
				});
			}

		}

		disconnectedCallback(){
			window.removeEventListener('resize', this._RESIZE_Handler);
			clearTimeout(this._openTimer);
			clearTimeout(this._closeTimer);
		}

		syncIds(){
			this.items.forEach((item, index)=>{
				const toggle = item.querySelector('[data-mega-nav-toggle]');
				const panel = item.querySelector('[data-mega-nav-panel]');
				if ( ! toggle || ! panel ) return;
				panel.id = `${panel.id.replace(/-sticky$/, '')}-sticky-${index}`;
				toggle.setAttribute('aria-controls', panel.id);
			});
		}

		scheduleOpen(item){
			clearTimeout(this._closeTimer);
			clearTimeout(this._openTimer);
			const delay = this._current && this._current !== item ? 0 : this.OPEN_DELAY;
			this._openTimer = setTimeout(()=>{
				this.open(item);
			}, delay);
		}

		scheduleClose(){
			clearTimeout(this._openTimer);
			clearTimeout(this._closeTimer);
			this._closeTimer = setTimeout(()=>{
				if ( this._current ) this.close(this._current);
			}, this.CLOSE_DELAY);
		}

		open(item){

			clearTimeout(this._closeTimer);

			if ( this._current && this._current !== item ) {
				this.close(this._current);
			}

			this.position(item);
			item.classList.add('is-open');

			const toggle = item.querySelector('[data-mega-nav-toggle]');
			if ( toggle ) toggle.setAttribute('aria-expanded', 'true');

			this._current = item;

		}

		close(item){

			if ( ! item ) return;

			item.classList.remove('is-open');

			const toggle = item.querySelector('[data-mega-nav-toggle]');
			if ( toggle ) toggle.setAttribute('aria-expanded', 'false');

			if ( this._current === item ) this._current = null;

		}

		positionAll(){
			this.items.forEach(item=>{
				this.position(item);
			});
		}

		position(item){

			const panel = item.querySelector('[data-mega-nav-panel]');
			if ( ! panel ) return;

			const inner = panel.querySelector('.mega-nav__panel-inner');
			if ( ! inner ) return;

			panel.style.setProperty('--mega-nav-panel-shift', '0px');

			const bar = item.closest('.header__bottom');
			if ( bar ) {
				const gap = bar.getBoundingClientRect().bottom - item.getBoundingClientRect().bottom;
				panel.style.setProperty('--mega-nav-panel-gap', `${Math.max(0, gap)}px`);
			}

			const rtl = document.documentElement.getAttribute('dir') === 'rtl';
			const margin = 20;
			const scrollX = window.scrollX || window.pageXOffset || 0;
			const pageWidth = document.documentElement.clientWidth;
			const rect = inner.getBoundingClientRect();

			if ( rect.width === 0 ) return;

			const left = rect.left + scrollX;
			const right = rect.right + scrollX;

			let delta = 0;

			if ( rtl ) {
				const overflow = margin - left;
				if ( overflow > 0 ) {
					delta = overflow;
				}
				if ( right + delta > pageWidth - margin ) {
					delta = ( pageWidth - margin ) - right;
				}
			} else {
				const overflow = right - ( pageWidth - margin );
				if ( overflow > 0 ) {
					delta = -overflow;
				}
				if ( left + delta < margin ) {
					delta = margin - left;
				}
			}

			const shift = rtl ? -delta : delta;

			panel.style.setProperty('--mega-nav-panel-shift', `${Math.round(shift)}px`);

		}

	}

	if ( typeof customElements.get('mega-nav') == 'undefined' ) {
		customElements.define('mega-nav', MegaNav);
	}

}
